import { createSortableTextHeader } from '@dealstack/frontend/shared/components/Table/MantineTable/ColumnHeader/ColumnHeader';

export const SINGLE_LINE_STYLE = { whiteSpace: 'nowrap' } as const;

export const createSingleLineHeader = <TData>(
	text: string,
	{
		align = 'left',
		enableSorting = true,
	}: { align?: 'left' | 'right'; enableSorting?: boolean } = {}
) =>
	createSortableTextHeader<TData>(text, enableSorting, {
		truncate: true,
		style: SINGLE_LINE_STYLE,
		...(align === 'right' && { ta: 'right', w: '100%' }),
	});
